<template>
<div class="box__container">
			<div class="box__header">
				<div class="box__header__title">
					<h2>{{ 'Voto Legal' | translate | capitalize }}</h2>
				</div>
			</div>
			<div class="box__body">
				<div class="box__body__subtitle">
					<p>{{ 'mail-voto-legal' | translate | capitalize }}</p>
				</div>
				<form @submit.prevent="votoLegalIntegration">
						<div class="form__group">
							<label for="votolegal-email">{{ 'mail-voto-legal' | translate | capitalize }}</label>
							<input type="email" id="votolegal-email" maxlength="256" name="email" placeholder="e-mail" v-model="votoLegal.votolegal_email" :disabled="true">
							<div class="has-error" v-if="erro">
								<label for="inputError"><i class="fas fa-times-circle-o"></i> {{ 'required-field' | translate | capitalize }}</label>
							</div>
						</div>

						<div class=" form__group">
							<label for="facebook-greeting">{{ 'votolegal-greeting' | translate | capitalize }}</label>
								<input id="facebook-greeting" type="text"  name="text" @input="count($event, 80)" maxlength="80" placeholder="posso ajudar?" v-model="votoLegal.greeting" :disabled="true">
								<span id="counter-facebook-greeting" class="label pull-right bg-red counter"></span>
							<div class="remove-button" v-if="this.votoLegal.votolegal_email" @click="removeIntegration()">
								<i class="fas fa-times"></i> {{ 'remove-integration' | translate | capitalize }}
							</div>
						</div>
						<div class="form__group submit__content">
							<button type="submit" :disabled="true" :aria-busy="submitLoading ? 'true' : 'false'">
								{{ 'save' | translate | capitalize }}
							</button>
						</div>
				</form>
						<div class="has-error" v-show="errorForm(error, 'votolegal_email')">
							<p>{{ 'no-account' | translate | capitalize }}<a href="https://participe.votolegal.com.br/pre-cadastro/" target="_blank"> {{ 'create-account' | translate | capitalize }}</a></p>
						</div>

						<div class="form__group has-success text-center">
							<label for="inputSuccess" v-if="integrationForm.success"><i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}</label>
						</div>
						<div class="form__group integration__votolegal">
							<a href="https://votolegal.com.br" target="_blank"><p>Voto Legal</p></a>
						</div>
			</div>
</div>

</template>
<script>
	export default {
		name: 'votoLegal',
		data() {
			return {
				session: {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
				},
				integrationForm: {
					success: false,
				},
				integration: {
					email: '',
					greeting: '',
				},
				erro: false,
				submitLoading: false,
			};
		},
		computed: {
			votoLegal() {
				const votoLegalIntegration = (this.$store.state.user || {}).votolegal_integration || {};
				return votoLegalIntegration;
			},
			user() {
				return this.$store.state.user;
			},
			error() {
				return this.$store.state.error;
			},
			success() {
				return this.$store.state.status;
			},
		},
		methods: {
			count(event, tam) {
				const lengthText = document.getElementById(`counter-${event.target.id}`);
				lengthText.textContent = (event.target.value.length - tam) * -1;
			},
			imgUrl(path) {
				return images(`./${path}`);
			},
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
			removeIntegration() {
				if (this.votoLegal.votolegal_email) {
					this.erro = false;

					const payload = {};
					payload.votolegal_email = this.votoLegal.votolegal_email;
					payload.greeting = this.votoLegal.greeting;
					payload.active = 0;

					this.toggleSubmitLoading();
					this.$store.dispatch('setIntegrations', payload)
						.then(() => {
							this.toggleSubmitLoading();
							this.integrationForm.success = this.success;
							setTimeout(() => {
								this.integrationForm.success = false;
							}, 5000);
							this.$store.dispatch('loadUser', this.session);
						})
						.catch(() => {
							this.toggleSubmitLoading();
						});
				} else {
					this.erro = true;
				}
			},
			votoLegalIntegration() {
				if (this.votoLegal.votolegal_email) {
					this.erro = false;

					const payload = {};
					payload.votolegal_email = this.votoLegal.votolegal_email;
					payload.greeting = this.votoLegal.greeting;
					payload.active = 1;

					this.toggleSubmitLoading();
					this.$store.dispatch('setIntegrations', payload)
						.then(() => {
							this.toggleSubmitLoading();
							this.integrationForm.success = this.success;
							setTimeout(() => {
								this.integrationForm.success = false;
							}, 5000);
							this.$store.dispatch('loadUser', this.session);
						})
						.catch(() => {
							this.toggleSubmitLoading();
						});
				} else {
					this.erro = true;
				}
			},
			errorForm(obj, field) {
				let erro = false;
				if (obj) {
					if (obj[field]) {
						erro = true;
					}
				}
				return erro;
			},
		},
		mounted() {

		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/integrations/votoLegal.vue